import { useMemo } from 'react';
import ChartOptions from '../../../../../components/Charts/Options';

import { TimeFrame } from '../../../../Detail/types';

import './index.css';

interface Props {
  higherTimeFrame: TimeFrame;
  setHigherTimeFrame: React.Dispatch<React.SetStateAction<TimeFrame>>;
  shorterTimeFrame: TimeFrame;
  setShorterTimeFrame: React.Dispatch<React.SetStateAction<TimeFrame>>;
  multiOrderTimeFrame: TimeFrame;
  setMultiOrderTimeFrame: React.Dispatch<React.SetStateAction<TimeFrame>>;
}

const TimesFramesForm = (props: Props) => {
  const {
    higherTimeFrame,
    setHigherTimeFrame,
    shorterTimeFrame,
    setShorterTimeFrame,
    multiOrderTimeFrame,
    setMultiOrderTimeFrame,
  } = props;

  const timeFrames = useMemo(() => Object.values(TimeFrame), []);

  return (
    <div className="single-profit-content-timeFrames">
      <h3 className="single-profit-content-timeFrames-label">
        Higher TimeFrame:
      </h3>
      <ChartOptions>
        <ChartOptions.OptionsWrapper scroll>
          {timeFrames.map((timeFrame) => (
            <ChartOptions.Option
              key={timeFrame}
              label={timeFrame}
              isSelected={timeFrame === higherTimeFrame}
              handleSelect={() => setHigherTimeFrame(timeFrame)}
            />
          ))}
        </ChartOptions.OptionsWrapper>
      </ChartOptions>

      <h3 className="single-profit-content-timeFrames-label margin-top-small">
        Shorter TimeFrame:
      </h3>
      <ChartOptions>
        <ChartOptions.OptionsWrapper scroll>
          {timeFrames.map((timeFrame) => (
            <ChartOptions.Option
              key={timeFrame}
              label={timeFrame}
              isSelected={timeFrame === shorterTimeFrame}
              handleSelect={() => setShorterTimeFrame(timeFrame)}
            />
          ))}
        </ChartOptions.OptionsWrapper>
      </ChartOptions>

      <h3 className="single-profit-content-timeFrames-label margin-top-small">
        Multi TimeFrame:
      </h3>
      <ChartOptions>
        <ChartOptions.OptionsWrapper scroll>
          {timeFrames.map((timeFrame) => (
            <ChartOptions.Option
              key={timeFrame}
              label={timeFrame}
              isSelected={timeFrame === multiOrderTimeFrame}
              handleSelect={() => setMultiOrderTimeFrame(timeFrame)}
            />
          ))}
        </ChartOptions.OptionsWrapper>
      </ChartOptions>
    </div>
  );
};

export default TimesFramesForm;
